import { Href, useRouter, useLocalSearchParams, useSegments } from 'expo-router';

import { ROUTES } from '@/constants/routes';

type NavigationParams = Record<string, string | undefined>;

export function useBackNavigation(defaultRoute: Href, params?: NavigationParams) {
  const { canGoBack, back, navigate } = useRouter();

  const { referred_by: referredBy } = useLocalSearchParams<{
    referred_by?: string;
  }>();

  const segments = useSegments() as string[];

  return {
    navigateBack: () => {
      const isLoginScreen = segments[1] === 'login';

      if (isLoginScreen) {
        if (
          typeof window !== 'undefined' &&
          typeof defaultRoute === 'string' &&
          defaultRoute.startsWith('http')
        ) {
          window.location.href = defaultRoute;

          return;
        }

        return navigate(defaultRoute);
      }

      if (referredBy) {
        return navigate(ROUTES.DIRECTORY as Href);
      }

      if (canGoBack()) {
        return back();
      }

      if (typeof defaultRoute === 'object' && defaultRoute !== null) {
        navigate(defaultRoute);
      } else {
        navigate({
          pathname: defaultRoute as never,
          params: params as never,
        });
      }
    },
  };
}
